import TournamentAwardDetail from './TournamentAwardDetail.component';
import { connector } from './TournamentAwardDetail.connector';

export const TournamentAwardDetailComponent = connector(TournamentAwardDetail);